import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=1e9daf22&scoped=true&"
import script from "./DefaultFooter.vue?vue&type=script&lang=js&"
export * from "./DefaultFooter.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=1e9daf22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9daf22",
  null
  
)

export default component.exports